import { Outlet } from 'react-router-dom';

import { StudentFeesLayout } from './components/StudentFeesLayout';

const StudentFees = () => {
  return (
    <StudentFeesLayout>
      <Outlet />
    </StudentFeesLayout>
  );
};

export { StudentFees };
